(() => {
  /* v546 — i messaggi della barra scorrono sempre verso sinistra, come su
     nike.com. In coda al nastro c'e' una copia del primo messaggio: arrivati
     li' il nastro torna all'inizio senza animazione (classe is-jumping), cosi'
     dall'ultimo al primo non si vede piu' lo scorrimento all'indietro. */
  const initPromo = (root) => {
    if (root.dataset.psiPromoReady === 'true') return;

    const track = root.querySelector('.psi-search-promo__track');
    const slides = Array.from(root.querySelectorAll('.psi-search-promo__slide'));
    if (!track || slides.length < 2) return;

    root.dataset.psiPromoReady = 'true';
    const clone = slides[0].cloneNode(true);
    clone.classList.remove('is-active');
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-psi-promo-clone', '');
    clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
    track.appendChild(clone);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = null;

    const place = (i, animate) => {
      track.classList.toggle('is-jumping', !animate);
      track.style.transform = `translate3d(-${i * 100}%,0,0)`;
    };

    const mark = () => {
      const real = index % slides.length;
      slides.forEach((slide, i) => {
        const active = i === real;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    };

    const next = () => {
      index += 1;
      place(index, true);
      mark();
    };

    track.addEventListener('transitionend', (event) => {
      if (event.target !== track || index < slides.length) return;
      index = 0;
      place(0, false);
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    });

    const stop = () => {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(next, 5000);
    };

    place(0, false);
    mark();
    void track.offsetWidth;
    track.classList.remove('is-jumping');
    start();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', start);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(start);
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-psi-search-promo]').forEach(initPromo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
